import type { DashboardDto } from "@stryker/core/types/dashboard";
import type { ReactNode } from "react";
import Expandable from "@/components/Expandable";
import { Card } from "@/components/ui/card";
import { Typography } from "@/components/ui/typography";

type SummaryProps = {
  summary: DashboardDto["summary"];
};
export default function Summary({ summary }: SummaryProps) {
  const bidWonPercentage = summary.jobCount ? ((summary.bidWon / summary.jobCount) * 100).toFixed(2) : "0";
  return (
    <Card className="my-4 flex flex-col gap-4 p-4">
      <Expandable
        titleClassName="items-start"
        title={
          <div className="flex w-full flex-wrap justify-between gap-4">
            <SummaryBlock title="Jobs count" value={summary.jobCount} />
            <SummaryBlock title="Bid Won" value={summary.bidWon} />
            <SummaryBlock title="Bid Lost" value={summary.bidLost} />
            <SummaryBlock title="Bid  won %" value={bidWonPercentage} />
          </div>
        }
      >
        <div className="flex flex-wrap justify-between gap-4 pr-10">
          <SummaryBlock title="Total Cost" value={summary.winningQuotes} />
          <SummaryBlock title="Total revenue" value={summary.finalRevenue} />
          <SummaryBlock title="Gross Profit" value={summary.extraLessRevenue} />
          <SummaryBlock title="Lost revenue(Lost Quotes)" value={summary.lostRevenue} />
          <SummaryBlock title="Kits sold" value={summary.kitsSold} />
        </div>
      </Expandable>
    </Card>
  );
}

type SummaryBlockProps = {
  title: string;
  value: ReactNode;
};

function SummaryBlock({ title, value }: SummaryBlockProps) {
  return (
    <Card className="min-w-full justify-start p-4 md:min-w-[140px] lg:min-w-[200px] 2xl:min-w-[300px]">
      <Typography variant="text-small" weight="semibold" className="text-left">
        {title}
      </Typography>
      <Typography variant="display-sm" weight="bold" className="text-wrap break-all text-left">
        {value}
      </Typography>
    </Card>
  );
}
